import { queryOptions } from "@tanstack/react-query";
import { apiClient } from "@/lib/api";
import { publicPath } from "@/lib/branch";
import { publicCatalogSchema, publicCombosSchema, publicStaffListSchema } from "../schemas/booking.schemas";

export const catalogKeys = {
  all: ["public-catalog"] as const,
  menu: () => [...catalogKeys.all, "menu"] as const,
  staff: () => [...catalogKeys.all, "staff"] as const,
  combos: () => [...catalogKeys.all, "combos"] as const,
};

// Each read is the branch's for a branch link (FR-SA-244). The page reloads when the branch changes, so the keys
// never hold two branches' answers.

/**
 * The salon's menu as a customer sees it (TDD-SA FR-SA-013): active headings, and the services a
 * customer may book themselves. Anonymous. A menu changes a few times a month, so it is not
 * refetched on every step of the booking flow.
 */
export const publicCatalogQuery = () =>
  queryOptions({
    queryKey: catalogKeys.menu(),
    queryFn: ({ signal }) => apiClient.get(publicCatalogSchema, publicPath("/catalog"), { signal }),
    staleTime: 5 * 60_000,
  });

/**
 * The stylists a customer may choose between (TDD-SA FR-SA-025). An empty list is a normal answer:
 * the salon does not offer the choice, and the booking flow simply skips the step.
 */
export const publicStaffQuery = () =>
  queryOptions({
    queryKey: catalogKeys.staff(),
    queryFn: ({ signal }) => apiClient.get(publicStaffListSchema, publicPath("/staff"), { signal }),
    staleTime: 5 * 60_000,
  });

/**
 * The combos a customer may book (TDD-SA FR-SA-223): several services at one price. Anonymous; a
 * failed read simply shows no combos, because the menu itself still books.
 */
export const publicCombosQuery = () =>
  queryOptions({
    queryKey: catalogKeys.combos(),
    queryFn: ({ signal }) => apiClient.get(publicCombosSchema, publicPath("/combos"), { signal }),
    staleTime: 5 * 60_000,
  });
